module.exports = __webpack_public_path__ + "img/112.5f27a7ab.jpg";